var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dsn-button',{attrs:{"size":"small","type":"primary","icon":"el-icon-search","disabled":_vm.disabled,"loading":_vm.loading,"round":_vm.round,"circle":_vm.circle,"autofocus":_vm.autofocus},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }